import axios from "axios"
import vueInstance from "../main"
import LoginUtils from "../util/LoginUtils"
import {translateValidations} from "./TranslateUtils"

let axiosApiInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

axiosApiInstance.interceptors
.request.use(
    async (config) => {

        putRequestToken(config)
        configRequestCustomConfig(config)

        return config
    }
)

axiosApiInstance.interceptors
.response.use(
    response => {

        let customConfig = response.config && response.config.customConfig

        configResponseCustomConfig(customConfig)
        
        return response.data != undefined && response.data != null ? response.data : response
    },
    error => {
        let customConfig = error.response && error.response.config && error.response.config.customConfig || 
                           error.config && error.config.customConfig || null

        configResponseCustomConfig(customConfig)

        handlerResponseErrors(error, customConfig)

        throw error
    }
)

function putRequestToken(config)
{
    if (config.url == "/oauth/token") {
        return
    }

    let tokenAccess = LoginUtils.getTokenAccess()

    if (tokenAccess)
    {
        config.headers = config.headers || {}
        config.headers['Authorization'] = `Bearer ${tokenAccess}`
    }
}

function handlerResponseErrors(error, customConfig)
{
    if (!error.response)
    {
        if (error.message == "Network Error") {
            let errorData = {errors: ["error_server_connection"]}
            translateMessages(errorData, customConfig)
            vueInstance.$store.dispatch('app/setGlobalErrors', errorData)
        }

        throw error
    }

    let data = error?.response?.data

    if ((error.response.status == 400) && error.response && error.response.data)
    {
        translateMessages(error.response.data, customConfig)

        let hasError =  data.errors && data.errors.length

        if (hasError && customConfig.showValidationAlert)
        {
            vueInstance.$store.dispatch('app/setGlobalErrors', data)
        }

        throw error.response.data
    }

    if ( [500].includes(error.response.status) )
    {
        translateMessages(error.response.data, customConfig)
        vueInstance.$store.dispatch('app/setGlobalErrors', error.response.data)

        throw error
    }

    if ( [401, 403].includes(error.response.status) )
    {
        if (error.response.status == 401)
        {
            LoginUtils.clearTokens()
            vueInstance.$store.dispatch('app/clearLoaders')
            vueInstance.$router.replace('/')
        }

        if (error.response.status == 403) {
            vueInstance.$store.dispatch('app/setGlobalErrors', {errors: ["Acesso negado!"]})
        }
    }
}

function translateMessages(data, customConfig)
{
    let context = customConfig && customConfig.context

    translateValidations(data, context)
}



function configRequestCustomConfig(config)
{
    if (config.customConfig)
    {
        if (config.customConfig.showLoader)
        {
            config.customConfig.loaderId = new Date().getTime() + (Math.random() * 16)
            vueInstance.$store.dispatch('app/addLoader', config.customConfig.loaderId)
        }
    }
}

function configResponseCustomConfig(customConfig)
{
    if (customConfig && customConfig.loaderId)
    {
        vueInstance.$store.dispatch('app/removeLoader', customConfig.loaderId)
    }
}

export default axiosApiInstance